<h1 style="margin-top:75px;margin-left:50px;color:blue"> 
    Welcome to <img style="height:40px;" src="assets/primeng/images/FarmLogoBlueWithText.png">!
</h1>
